import React from 'react'
import { useEffect, useRef, useState } from 'react'
import styles from './style.module.scss'

import closeDrawer from 'assets/images/calendar/toolbar-close-pane.svg'
import syncSVG from 'assets/images/toolbar-sync-24.svg'
import addSVG from 'assets/images/todo/icon-add.svg'
import SVG from 'react-inlinesvg'

import { modalTodoEditor } from 'pages/todo/components/TodoEditor'
import { PRIORITY, TODO_STATUS } from 'pages/todo/modules/TodoItem'
import * as todoSync from 'pages/todo/modules/TodoSync'

interface TaskDrawerHeaderProps {
  headerHeight: number
  onClose: () => void
}

const TaskDrawerHeader: React.FC<TaskDrawerHeaderProps> = ({ headerHeight, onClose }) => {
  const [isRotating, setIsRotating] = useState(false)
  const rotateTimeExpired = useRef(true)

  const syncListener = (isFetching: boolean) => {
    if (isFetching) {
      setIsRotating(true)
      rotateTimeExpired.current = false

      setTimeout(() => {
        if (!todoSync.isSyncing()) {
          setIsRotating(false)
        }
        rotateTimeExpired.current = true
      }, 1000)
    } else if (rotateTimeExpired.current) {
      setIsRotating(false)
    }
  }

  useEffect(() => {
    todoSync.addTodoSyncListener(syncListener)
    return () => {
      todoSync.removeTodoSyncListener(syncListener)
    }
  }, [])

  const handleSyncClick = () => {
    if (isRotating) return

    setIsRotating(true)
    todoSync.reloadTodos(true)
  }

  const handleAddClick = () => {
    const newTodo = {
      url: null,
      folderId: null,
      summary: '',
      description: '',
      status: TODO_STATUS.NEEDS_ACTION,
      priority: PRIORITY.MEDIUM,
      percentComplete: 0,
      startDate: null,
      dueDate: null,
      location: '',
      alarms: [],
    }
    modalTodoEditor(newTodo)
  }

  return (
    <div className={styles.taskDrawerHeader} style={{ height: headerHeight }}>
      <div className={styles.drawerCloseButton} onClick={onClose}>
        <img src={closeDrawer} alt="closeDrawer" />
      </div>
      <div className={styles.taskDrawerRightBtns}>
        <div className={styles.taskDrawerRightBtn} onClick={handleSyncClick}>
          <img src={syncSVG} alt="syncTask" className={isRotating ? styles.rotating : ''} />
        </div>
        <div className={styles.taskDrawerRightBtn} onClick={handleAddClick}>
          <SVG src={addSVG} {...({ alt: 'addTask', color: '#1F2937' } as any)} />
        </div>
      </div>
    </div>
  )
}

export default TaskDrawerHeader
